<template>
  <div class="tw-flex tw-flex-col tw-gap-2">
    <small
      class="d-block tw-mx-auto"
      :class="isOnboardingRedesign && 'tw-text-sm md:tw-text-base lg:tw-text-lg'"
    >
      Already have an account?
      <router-link
        v-if="isOnboardingRedesign"
        to="/login"
      >
        Log in
      </router-link>
      <router-link
        v-else
        to="/login"
      >
        Sign In
      </router-link>
    </small>

    <img
      :src="isOnboardingRedesign ? require(`@/assets/images/cro/hsa-fsa-eligible-badge.svg`) : require(`@/assets/images/cro/hsa-fsa-eligible-badge.png`)"
      alt=""
      class="tw-mx-auto"
      :class="isOnboardingRedesign ? 'tw-h-[30px]' : 'tw-h-[18px]'"
    >
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
  }
}
</script>